'use client';

import Icon, { AppleFilled, StarFilled } from '@ant-design/icons';

import AndroidSvg from '@/components/Icon/svgs/android.svg';
import { useTranslation } from '@/i18n/client';
import { AppStoreLink, GooglePlayLink } from '@/utils/call-app';
import reportClick, { EReportClickKey } from '@/utils/report/reportClick';

const PhoneAdvertise = (props: { type?: string }) => {
  const { type = 'ios' } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 mt-7 items-center w-full max-w-[800px] mx-auto">
      <div className="bg-[rgba(254,253,255,0.6)] px-4 py-8 flex flex-col gap-9 items-center w-full rounded-[16px]">
        <div className="text-primary-black flex flex-col items-center">
          <div className="font-[Calistoga-Regular] text-[32px] leading-[48px] ">
            {type === 'ios'
              ? t('leftTabs.phoneModal.iosTitle')
              : t('leftTabs.phoneModal.androidTitle')}
          </div>
          <div className="text-lg leading-8 font-bold text-[#756c5d]">
            {t('leftTabs.phoneModal.tip')}
          </div>
        </div>

        <div className="flex items-center">
          <img
            alt="MindOSLogo"
            className="w-[74px] h-[74px] rounded-[12px]"
            src="https://frontdoorcdn.mindverse.ai/mindos-resource/front-img/crm/202406201718886825212APPICON.png"
          />
          <div className="flex flex-col ml-4 w-[210px]">
            <div className="text-sm leading-6 font-medium text-primary-black">Second Me</div>
            <div className=" text-xs leading-4 text-[#756C5D] ">
              {t('leftTabs.phoneModal.appDescription')}
            </div>
            <div className="flex items-center gap-1 mt-1">
              <div className="flex items-center gap-[2px] text-base leading-4 text-[#F8AE00]">
                <StarFilled />
                <StarFilled />
                <StarFilled />
                <StarFilled />
                <StarFilled />
              </div>
              <div className="text-xs leading-4 text-[#756C5D]">4.8</div>
            </div>
          </div>
        </div>

        <div
          className="cursor-pointer bg-primary-black text-primary-white flex py-2 px-5 items-center justify-center rounded-[40px] gap-2 transition-colors hover:bg-primary-sub-color"
          onClick={() => {
            reportClick(EReportClickKey.open_in_app_clicked, {
              key1: 'getAppPage',
              key3: type
            });
            window.open(type === 'ios' ? AppStoreLink : GooglePlayLink, '_blank');
          }}
        >
          {type === 'ios' ? (
            <AppleFilled className="text-[20px]" />
          ) : (
            <Icon className="text-[20px]" component={AndroidSvg} />
          )}
          <div className="text-lg leading-8 font-medium">{t('leftTabs.phoneModal.getApp')}</div>
        </div>

        <div className="border-0 border-t-[1px] border-solid border-[#fefdff] w-full" />

        <div className="flex flex-col items-center gap-4">
          <img
            className="w-[120px] h-[120px]"
            src={
              // 'https://frontdoorcdn.mindverse.ai/mindos-resource/front-img/crm/202406191718780481326qrcode.jpeg'
              // 'https://frontdoorcdn.mindverse.ai/mindos-resource/front-img/crm/202406191718780965806qrcode_mebot.png'
              // 'https://frontdoorcdn.mindverse.ai/mindos-resource/front-img/crm/202406191718781101243qrcode_mebot_1.png'
              type === 'ios'
                ? 'https://frontdoorcdn.mindverse.ai/mindos-resource/front-img/crm/202408201724121960830appstore.png'
                : 'https://frontdoorcdn.mindverse.ai/mindos-resource/front-img/crm/202408201724121960832googleplay.png'
            }
          />
          <div className="text-[18px] leading-8 font-medium text-primary-black">
            {t('leftTabs.phoneModal.qrTip')}
          </div>
        </div>
      </div>

      {/* <div className="bg-[rgba(254,253,255,0.3)] py-8 flex flex-col gap-4 items-center w-full rounded-[16px]">
        <div className="text-[18px] leading-[32px] font-medium text-[#756c5d]">Coming Soon</div>
        <div
          className="cursor-pointer bg-primary-black text-primary-white flex py-2 px-5 items-center justify-center rounded-[40px] gap-2 transition-colors hover:bg-primary-sub-color"
          onClick={() => {
            window.open(
              'https://docs.google.com/forms/d/e/1FAIpQLSf3xzqzBftNQ5Adcpbf9NPYta4OyBd3SxzQFQNqSeQ9wfl2zg/viewform',
              '_blank'
            );
          }}
        >
          <AndroidFilled className="text-[20px]" />
          <div className="text-lg leading-8 font-medium">Join Android Wait-list</div>
        </div>
      </div> */}
    </div>
  );
};

export default PhoneAdvertise;
